import LogisticsCompany from "@/enum/LogisticsCompany";
import LogisticsCompanyType from "@/enum/LogisticsCompanyType";
import SharedEwaybillAccountType from "@/enum/SharedEwaybillAccountType";
import UserType from "@/enum/UserType";
import { get } from "@/services/http/backend";
import { PagedResult } from "./types";

export enum SharedEwaybillShippingAddressStatus {
  DELETED = "DELETED",
  DISABLE = "DISABLE",
  ENABLE = "ENABLE",
}
export interface GetSharedEwaybillAccountListParams {
  /**
   * 备注/使用面单的人
   */
  consumerName?: string;

  /**
   * 待查询的（非已共享）电子面单账号 ID，为空表示查询全部。
   */
  ewaybillAccountId?: number;

  /**
   * 待查询的（非已共享）网点电子面单账号 ID，为空表示查询全部。
   */
  ewaybillBranchAccountId?: number;

  /**
   * 待查询的物流公司（快递）类型，为空表示查询全部
   */
  logisticsCompany?: LogisticsCompany;

  /**
   * 单号余额最大值（上限，包含），为空表示不限制。
   */
  minQuantity?: number;

  /**
   * 单号余额最小值（下限，包含），为空表示不限制。
   */
  maxQuantity?: number;

  /**
   * 共享发货地址的状态
   */
  statuses?: SharedEwaybillShippingAddressStatus[];

  pageNo: number;

  pageSize: number;

  userType: UserType;
}

export interface SharedEwaybillShippingAddress {
  accessToken: string;
  allocatedQuantity: number;
  cancelQuantity: number;
  city: string;
  consumerCompanyId: number;
  consumerName: string;
  dateCreated: string;
  district: string;
  enabled: boolean;
  ewaybillAccountId: number;
  ewaybillShippingAddressId: number;
  id: number;
  providerCompanyId: number;
  province: string;
  quantity: number;
  status: SharedEwaybillShippingAddressStatus;
  street: string;
  town: string;
  unlimitedQuantity: boolean;
  /** 关联的电子面单账号是否被删除 */
  isRelatedEwaybillAccountDeleted: boolean;
  doNotIncreaseQuantityWhenRecycle: boolean;
}

export interface SharedEwaybillBranchAccount {
  id: number;
  branchCode: string;
  branchName: string;
  ewaybillBranchAccountId: number;
  serviceOptionsJson: string;
  shippingAddresses: SharedEwaybillShippingAddress[];
  waybillNoTypeCode: string;
  waybillNoTypeName: string;
}

export interface SharedEwaybillSubscription {
  id: number;
  branchAccounts: SharedEwaybillBranchAccount[];
  ewaybillSubscriptionId: number;
  logisticsCompany: LogisticsCompany;
  logisticsCompanyType: LogisticsCompanyType;
  supportsChildWaybillNoType: boolean;
}
export interface SharedEwaybillAccount {
  id: number;
  consumerCompanyId: number;
  consumerCompanyName: string;
  ewaybillAccountId: number;
  platformUserId: number;
  platformUsername: string;
  providerCompanyId: number;
  providerCompanyName: string;
  subscriptions: SharedEwaybillSubscription[];
  type: SharedEwaybillAccountType;
  /** 展示电子面单账号的时候，优先展示非空的 name 字段,其次是 platformUsername */
  name?: string;
}

type SharedEwaybillAccountListResult = PagedResult<SharedEwaybillAccount>;

/**
 * 获取共享的电子面单账号
 */
export function getSharedEwaybillAccountList(params: GetSharedEwaybillAccountListParams) {
  // @ts-ignore
  params.statuses = params?.statuses?.join(",");

  return get("/shared_ewaybill_account/list", params) as Promise<SharedEwaybillAccountListResult>;
}

export function getEwaybillAccountMapping(ewaybillAccounts: SharedEwaybillAccount[]) {
  const ewaybillShippingAddressMapping = new Map<number, SharedEwaybillShippingAddress>();
  const branchAccountMapping = new Map<number, SharedEwaybillBranchAccount>();
  const subscriptionMapping = new Map<number, SharedEwaybillSubscription>();
  const ewaybillAccountMapping = new Map<number, SharedEwaybillAccount>();

  const allShippingAddresses: SharedEwaybillShippingAddress[] = [];

  ewaybillAccounts?.forEach((account) => {
    account.subscriptions?.forEach((subscription) => {
      subscription.branchAccounts?.forEach((branchAccount) => {
        branchAccount.shippingAddresses?.forEach((shippingAddress) => {
          ewaybillShippingAddressMapping.set(shippingAddress.id, shippingAddress);

          branchAccountMapping.set(shippingAddress.id, branchAccount);

          subscriptionMapping.set(shippingAddress.id, subscription);

          ewaybillAccountMapping.set(shippingAddress.id, account);

          allShippingAddresses.push(shippingAddress);
        });
      });
    });
  });

  return {
    ewaybillShippingAddressMapping,
    branchAccountMapping,
    subscriptionMapping,
    ewaybillAccountMapping,
    allShippingAddresses,
  };
}
